//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { KEYCODES, KEYS } from '@constants/keyboard';

export const keyEquals = (event: KeyboardEvent | React.KeyboardEvent, keyId: KEYS) => {
  return event.key === keyId || event.keyCode === KEYCODES[keyId];
};
